import { render } from "./ProducerAreaRateTable.vue?vue&type=template&id=109d82e3&scoped=true"
import script from "./ProducerAreaRateTable.vue?vue&type=script&lang=js"
export * from "./ProducerAreaRateTable.vue?vue&type=script&lang=js"

import "./ProducerAreaRateTable.vue?vue&type=style&index=0&id=109d82e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109d82e3"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
